<template>
    <section class="page-content">
        <div class="user-form-box">
            <div class="form-error" v-if="formError">{{ formError }}</div>
            <div class="small-box">
                <span v-if="isAdmin || userToEdit.id === currentUser.id">
                    <div class="row">
                        <div class="col-6">
                            <md-field>
                                <label>First Name</label>
                                <md-input v-model="userToEdit.firstName"></md-input>
                            </md-field>
                        <div class="user-edit-error" v-if="$v.userToEdit.firstName.$invalid">This field is required.</div>
                        </div>
                        <div class="col-6">
                            <md-field>
                                <label>Last Name</label>
                                <md-input v-model="userToEdit.lastName"></md-input>
                            </md-field>
                        <div class="user-edit-error" v-if="$v.userToEdit.lastName.$invalid">This field is required.</div>
                        </div>
                    </div>
                </span>
                <div v-else class="user-info"><span class="grey-text">Name </span> {{ userToEdit.firstName + ' ' + userToEdit.lastName }}</div>
                <div class="row">
                    <div class="col-6">
                            <span v-if="isAdmin || userToEdit.id === currentUser.id">
                                <md-field>
                                    <label>Email</label>
                                    <md-input v-if="isAdmin" v-model="userToEdit.email"></md-input>
                                    <md-input v-else v-model="userToEdit.email" disabled></md-input>
                                </md-field>
                                <div class="user-edit-error" v-if="$v.userToEdit.email.$invalid">Please enter a valid email.</div>
                            </span>
                        <div v-else class="user-info"> {{ userToEdit.email }}</div>
                    </div>
                    <div class="col-6">
                            <span v-if="isAdmin || userToEdit.id === currentUser.id">
                                <md-field>
                                    <label>Position</label>
                                    <md-input v-model="userToEdit.title"></md-input>
                                </md-field>
                                <div class="user-edit-error" v-if="$v.userToEdit.title.$invalid">This field is required.</div>
                            </span>
                        <div v-else class="user-info"><span class="grey-text">Role </span> {{ userToEdit.title }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                            <span v-if="isAdmin || userToEdit.id === currentUser.id">
                                <md-field>
                                    <label>Office Number</label>
                                    <md-input v-model="userToEdit.officePhone"></md-input>
                                </md-field>
                                <div class="user-edit-error" v-if="$v.userToEdit.officePhone.$invalid">Please enter a valid phone number.</div>
                            </span>
                        <div v-else class="user-info"><span class="grey-text">Office </span> {{ userToEdit.officePhone }}</div>
                    </div>
                    <div class="col-6">
                            <span v-if="isAdmin || userToEdit.id === currentUser.id">
                                <md-field>
                                    <label>Direct Number</label>
                                    <md-input v-model="userToEdit.directPhone"></md-input>
                                </md-field>
                                <div class="user-edit-error" v-if="$v.userToEdit.directPhone.$invalid">Please enter a valid phone number.</div>
                            </span>
                        <div v-else class="user-info"><span class="grey-text">Direct </span> {{ userToEdit.directPhone }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div v-if="!clientActive && isAdmin" class="primary-contact">
                            <div>
                                <md-checkbox v-model="superadmincheckbox" aria-label="Primary Contact" v-if="isSuperAdmin" @change="setUserAsAdmin">
                                    Cortex Super Admin
                                </md-checkbox>
                            </div>
                            <div>
                                <md-checkbox v-model="admincheckBox" aria-label="Primary Contact">
                                    Cortex Admin
                                </md-checkbox>
                            </div>
                            <div id="demo" v-if="clientList.length > 0 && !admincheckBox">
                                <div v-for="(client, index) in clientList">
                                    <input type="checkbox" class="multiple_select" v-model="selectClient" :id="'category_' + client.id" :value="client.id"/>
                                    <label>{{ client.companyName }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="success" v-if="adminEditedFields">
                    Record updated successfully!
                    <span @click="hideNotification">X</span>
                </div>
                <md-button class="md-raised md-primary" v-if="isAdmin" @click="saveUserChanges()">Save Changes</md-button>
                <md-button class="md-raised md-primary" v-else @click="saveUserChangesForClient()"> Save Changes</md-button>
                <div v-if="userToEdit.last_activity == null">
                    <md-button class="md-raised md-primary" v-if="isAdmin" @click="resendUserChanges(userToEdit.id)">Resend E-Mail</md-button>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
                {{ this.message }}
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
    </section>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {required, email} from 'vuelidate/lib/validators';
import {updateUser, updateUserForClient} from '../../services/UserService.js';
import {notWhitespace, validPhoneNumber} from '../../includes/validations.js';

export default {
  data: () => ({
    el: '#demo',
    name: 'MultipleSelect',
    formError: null,
    selectClient: [],
    admincheckBox: '',
    superadmincheckbox: '',
    adminEditedFields: false,
    showDeleteDialog: false,
    message: ''
  }),
  computed: {
    ...mapGetters('client', ['clientActive', 'clientList']),
    ...mapGetters('user', ['currentUser', 'userToEdit', 'userEdited', 'isAdmin', 'isSuperAdmin'])
  },
  methods: {
    ...mapActions('user', ['updateUserProfile', 'setUserToEdit']),
    setUserAsAdmin: function () {
      this.userToEdit['isAdmin'] = 0;
      if (this.superadmincheckbox === 'on') {
        this.admincheckBox = 'on';
        this.userToEdit['isAdmin'] = 1;
      }
    },
    touchHanlder (key) {
      if (!this.$v.userToEdit[key].$dirty) {
        this.$v.userToEdit[key].$touch();
      }
    },
    async saveUserChangesForClient () {
      await updateUserForClient(this.userToEdit).then(response => {
        this.updateUserProfile(this.userToEdit);
        this.adminEditedFields = true;
        setTimeout(() => {
          this.adminEditedFields = false;
        }, 3000);
      });
    },
    async saveUserChanges () {
      if (this.superadmincheckbox === 'on') {
        this.userToEdit['isSuperAdmin'] = 1;
      } else {
        this.userToEdit['isSuperAdmin'] = 0;
      }

      if (this.admincheckBox === 'on') {
        this.userToEdit['isAdmin'] = 1;
        this.userToEdit['user_clients_map'] = this.userToEdit.clientId;
      } else {
        this.userToEdit['isAdmin'] = 0;
      }
      this.userToEdit['user_clients_map'] = this.selectClient;

      await updateUser(this.userToEdit)
        .then(response => {
          if (this.userToEdit.id === this.currentUser.id) {
            this.userToEdit['selectClient'] = this.userToEdit;
            this.updateUserProfile(this.userToEdit);
          }
          this.setUserToEdit(this.userToEdit);
          this.formError = null;
          this.adminEditedFields = true;
          setTimeout(() => {
            this.adminEditedFields = false;
          }, 3000);
        })
        .catch(error => {
          if (error.response.data.type === 'DUPLICATE_EMAIL') {
            this.formError = error.response.data.message;
          }
        });
    },
    async resendUserChanges (userId) {
      await updateUser(userId)
        .then(response => {
          setTimeout(() => {
            this.adminEditedFields = false;
          }, 3000);
          if (response.data === 'Email send successfully') {
            this.message = 'Email send successfully';
          }
          this.showDeleteDialog = true;
        })
        .catch(error => {
          if (error.response.data.type === 'DUPLICATE_EMAIL') {
            this.formError = error.response.data.message;
          }
        });
    },
    hideNotification () {
      this.adminEditedFields = false;
    },
    closeDialog () {
      this.showDeleteDialog = false;
      this.message = null;
    }
  },
  mounted () {
    for (var i = 0; i < this.userToEdit.user_clients_map.length; i++) {
      this.selectClient.push(this.userToEdit.user_clients_map[i].client_id);
    }
    this.userToEdit.user_clients_map = [];
    this.userToEdit.user_clients_map = this.selectClient;
    if (this.userToEdit.isAdmin === 1) {
      this.admincheckBox = 'on';
    } else {
      this.admincheckBox = this.userToEdit.isAdmin;
    }
    if (this.userToEdit.isSuperAdmin === 1) {
      this.superadmincheckbox = 'on';
    }
    this.adminEditedFields = false;
  },
  validations: {
    userToEdit: {
      firstName: {
        required,
        notWhitespace
      },
      lastName: {
        required,
        notWhitespace
      },
      title: {
        required,
        notWhitespace
      },
      email: {
        required,
        email
      },
      directPhone: {
        required,
        notWhitespace,
        validPhoneNumber
      },
      officePhone: {
        required,
        notWhitespace,
        validPhoneNumber
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-user .wrap {
    margin: 0 !important;
}

.multiple_select {
    width: 20px;
    min-width: 22px;
    height: 20px;
    position: relative;
    border-radius: 2px;
    border: 2px solid transparent;
    cursor: pointer;
}

.form-error {
    font-size: 15px;
    color: red;
}

.user-edit-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.user-info {
    margin: 20px 0px 20px 0px;
    font-weight: 500;
}

.small-box {
    margin-top: 40px;
    margin-left: 10%;
    width: 60%;
}

.grey-text {
    color: #BEC2C5;
}

.success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    position: relative;
    padding: .75rem 1.25rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    top: 20px;
}

.success span {
    position: absolute;
    right: -2px;
    top: -5px;
    font-weight: bold;
    cursor: pointer;
}

#demo {

    height: 150px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/EditUserProfile.vue